
import { Component, Vue } from 'vue-property-decorator'

@Component
export default class CookiesDisclaimer extends Vue {
  showed = true

  mounted() {
    this.showed = Boolean(this.$cookies.get('cookiePrivatePolicy'))

    this.saveState()
  }

  private saveState() {
    this.$cookies.set('cookiePrivatePolicy', 'notified')
  }
}
